module.exports = __webpack_public_path__ + "static/media/Decisions_Step2_Image22.d08f55bb.webp";